import { Box, Stack, Typography } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'

export default function PauseBanner({ message }: any) {

    return (
        <Box p={custom.spacing.xxs} 
            sx={{ backgroundColor: 'sz.colors.surfaceAccent' }}>
            <Stack direction="row" 
                    spacing={custom.spacing.xxs}>
                <Box
                    component={'img'}
                    loading="lazy"
                    alt="Pause Icon"
                    src="/images/PauseIcon.svg"
                    p={custom.spacing.xxxxs}
                    alignItems="center"
                />
                <Typography variant="szBody.Regular.Small"
                    id="hotwaterEnergySavingPausedMessage">
                    {message}
                </Typography>
            </Stack>
        </Box>
    )
}

